<template lang="pug">
  .cardProduct(v-if="cardProduct", :data-id="cardProduct.id")
    a.cardProduct__card(v-if="cardProduct.link", :href="cardProduct.link")
    .cardProduct__card(v-else)
      .cardProduct__card-image
        Select(v-if="cardProduct.size", :data="cardProduct.size", @setCurrentSelect="changePrice")
        img.cardProduct__card-img(v-if="cardProduct.img", :src="cardProduct.img", alt="")
      .cardProduct__card-content
        .cardProduct__card-title(v-if="cardProduct.title")
          | {{cardProduct.title}}
        .cardProduct__card-description(v-if="cardProduct.text")
          | {{cardProduct.text}}
        .cardProduct__card-oldPrice(v-if="cardProduct.oldPrice")
          span {{cardProduct.oldPrice.value}}
          | {{cardProduct.oldPrice.currency}}
        .cardProduct__card-price(v-if="cardProduct.price")
          | {{cardProduct.price.value}}
          span {{cardProduct.price.currency}}
    button.cardProduct__cart(@click="addToCartLocal(cardProduct.id, 1, $event)")
      SvgIcon.cardProduct__cart-ico(name="cart", width="16", height="16")
</template>

<script>
  import '@/components/common/cardProduct/cardProduct.styl';

  import EventBus from '@/eventBus';
  import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';
  import Select from '@/components/common/select/select.vue';
  import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
  import {CartHelpersVue} from '@/mixins/CartHelpersVue';

  export default {
    name: 'CardProduct',

    mixins: [AjaxHelpersVue, CartHelpersVue],

    props: ['cardProduct'],

    components: {
      SvgIcon,
      Select
    },

    data() {
      return {

      }
    },

    created() {
      this.$nextTick(() => {
        this.initFancy();
      });
    },

    methods: {
      addToCartLocal(productId, count, e) {
        let size = $(e.target).parents('.cardProduct').find('.PrologueUniVueComponentSelect__native').val();

        let params = {
          productId: productId,
          count: count,
          size: size
        };

        this.addToCart((res) => {
          if(this.checkProperty(res.total)) {
            let count = res.total.count;

            this.$nextTick(() => {
              $('.header__cart-count').text(count);

              if(count > 0) {
                $('.header__cart-count').removeClass('header__cart-count--hide');
              } else {
                $('.header__cart-count').addClass('header__cart-count--hide');
              }
            });
          }
        }, params);
      },

      initFancy() {
        $('.cardProduct__card-content, .cardProduct__card-img').fancybox({
          src: '#popupProduct',
          touch: false,
          buttons: [],
          baseClass: 'popup-product-fancy',
          animationEffect: 'zoom-in-out',
          beforeShow: function() {
            $('.page').addClass('popup popup--effect');
            let productId = $.fancybox.getInstance().current.opts.$orig.parents('.cardProduct').data('id');
            EventBus.$emit('loadPopupProduct', {productId: productId});
          },
          beforeClose: function() {
            $('.page').removeClass('popup popup--effect');
            EventBus.$emit('clearPopupProduct');
          }
        });
      },

      changePrice(res) {
        let params = {
          productId: this.cardProduct.id,
          size: res.value
        };

        this.req('MenuPage:changeProductPrice', {...params}, res => {
          if(this.checkProperty(res.status) && res.status == 'ok') {
            this.cardProduct.oldPrice = res.oldPrice;
            this.cardProduct.price = res.price;
          }
        }, '', 'localPageRequest');
      }
    }
  }
</script>
